var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CurrentStockAdjustTemp',{attrs:{"goods-option":"S0104","goods-type":"다공정품"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }